
import moment from "moment";
import Box from '../Layout/Wrappers/Box';
import DatePicker from '../Layout/Wrappers/DatePicker';
import {
  REACT_TABLE__INPUT_RANGE_DATE
} from './useEnhancedReactTable.hook';

export const DATE_FORMAT = `MM-DD-YYYY`;

export function FilterDateRangeColumn({
  column: {
    id: columnId,
    preFilteredRows
  },
  filters = {},
  setFilter = () => { },
}) {

  let values = [];
  let columnFilters = filters[columnId] || {};
  values[0] = columnFilters['$gte'] ? moment(columnFilters['$gte']) : values[0];
  values[1] = columnFilters['$lte'] ? moment(columnFilters['$lte']) : values[1];

  const _setFilters = values => {

    values = values.map(value => ((value === undefined) ? null : value));

    let mongoRange = {};

    if (values[0]) { mongoRange['$gte'] = values[0]; }
    if (values[1]) { mongoRange['$lte'] = values[1]; }

    console.debug('values', values);

    setFilter({
      columnId,
      value: (values[0] || values[1]) ? mongoRange : undefined
    });

  }

  return (
    <Box row noWrap>
      <DatePicker
        placeholder={`${moment().subtract(180, 'days').format(DATE_FORMAT)}`}
        value={values[0]}
        onChange={(event, date) => {
          let value = date;
          _setFilters([value, values[1]]);
        }}
        className="mr-1"
        style={{
          minWidth: REACT_TABLE__INPUT_RANGE_DATE
        }}
      />
      <span className="mr-1">to</span>
      <DatePicker
        placeholder={`${moment().add(1, 'days').format(DATE_FORMAT)}`}
        value={values[1]}
        onChange={(event, date) => {
          let value = date;
          _setFilters([values[0], value]);
        }}
        className="mr-1"
        style={{
          minWidth: REACT_TABLE__INPUT_RANGE_DATE
        }}
      />
    </Box>
  );
}
